import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ITaxonomy } from 'app/interfaces/search.interface';
import { NotificationsService } from 'app/services/notifications.service';
import { TaxonomyService } from 'app/services/taxonomy.service';
import { PromptuarySidebarService } from 'modules/promptuary/services/sidebar/promptuary-sidebar.service';
import { AppointmentService } from 'shared/services/appointment/appointment.service';

@Component({
	selector: 'promptuary-no-show',
	templateUrl: './promptuary-no-show.component.html',
	styleUrls: ['./promptuary-no-show.component.scss'],
})
export class PromptuaryNoShow implements OnInit {
	firstDisplay = true;
	noshowStatus: boolean;
	reasonsList: ITaxonomy[];
	savingReason = false;
	selectedReasonId: string;
	noShowConfirmed: boolean | null = null;
	loadingConfirmNoShow = false;

	readonly noShowToggleId = 'noShow-checkbox';

	@Input() type = 'page';
	@Input() appointment: {
		noShow: boolean;
		noShowReasonId: string;
		notEditable: boolean;
		id: string;
		sessionInFuture: boolean;
	};
	@Output('changeNoshow') emChange: EventEmitter<boolean> =
		new EventEmitter<boolean>();
	constructor(
		public appointmentService: AppointmentService,
		public notificationService: NotificationsService,
		public taxonomyService: TaxonomyService,
		public translateService: TranslateService,
		public promptuarySidebarService: PromptuarySidebarService
	) {}

	ngOnInit(): void {
		this.noShowConfirmed = null;
		this.noshowStatus = this.appointment.noShow;
		this.selectedReasonId = this.appointment.noShowReasonId || '';

		this.taxonomyService.getNoshowReasons().subscribe(
			(result) => {
				this.reasonsList = result;
			},
			(error) => {
				this.notificationService.showError(error.message);
			}
		);
	}

	changeCheckbox(status: boolean): void {
		this.emChange.emit(status);
		this.noshowStatus = status;
		this.firstDisplay = false;
		if (status === false) {
			this.selectedReasonId = null;
		}
	}

	saveNoshowReason(noShowConfirmed?: boolean): void {
		if (
			this.appointment.notEditable ||
			(this.noshowStatus && !this.selectedReasonId)
		) {
			return;
		}

		this.noShowConfirmed = noShowConfirmed ?? this.noShowConfirmed;
		if (this.noshowStatus && !this.noShowConfirmed) {
			this.noShowConfirmed = false;
			return;
		}
		this.loadingConfirmNoShow = this.noshowStatus;
		this.savingReason = true;
		this.appointmentService
			.setNoshow(this.appointment.id, this.noshowStatus, this.selectedReasonId)
			.subscribe(
				() => {
					this.savingReason = false;
					this.appointment.notEditable =
						this.appointment.notEditable || this.noshowStatus;
					this.promptuarySidebarService.noShowObservable.next({
						appointmentId: this.appointment.id,
						reasonId: this.selectedReasonId,
						noShow: this.noshowStatus,
						notEditable: this.appointment.notEditable,
					});
					this.noshowStatus &&
						this.notificationService.showSuccess(
							this.translateService.instant('SCHEDULE.SEND_REPOSITION_INVITE'),
							this.translateService.instant('SCHEDULE.CONFIRMED_NO')
						);
					this.appointment.noShow = this.noshowStatus;
					this.noShowConfirmed = null;
					this.loadingConfirmNoShow = false;
				},
				({ error }) => {
					let message = '';

					if (error.message === 'EventNotStarted') {
						message = this.translateService.instant(
							'CONTACT.ERRORS.NOT_HAPPENED'
						);
					}

					this.noShowConfirmed = null;
					this.loadingConfirmNoShow = false;
					this.savingReason = false;
					this.notificationService.showError(message || error.messageI18n);
				}
			);
	}

	formatNoShowId(id: string) {
		return `${this.noShowToggleId}-${id}`;
	}

	closeNoShowModal() {
		this.noShowConfirmed = null;
	}
}
